import React from "react";
import ButtonWithImg from "../ButtonWithImg/ButtonWithImg";
import "./AccountNavBar.scss";
import { Avatar, Divider, IconButton, Tab, Tabs } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect } from "react";
import { launchSDK } from "../../../utils/helper";
import { useState } from "react";
import add_account_btn from "../../../assets/images/add_account_btn.svg";
import PublishIcon from "../tabIcons/PublishIcon";
import InsightIcon from "../tabIcons/InsightIcon";
const PUBLISH_PLATFORMS = ["TikTok", "Instagram", "YouTube"];

function AccountNavBar({
  setTabValue,
  tabValue,
  accountInfo,
  selectedPlatform,
  setSelectedPlatform,
  history,
}) {
  const mobileBreakPoint = useMediaQuery("(max-width:430px)");
  const tabStyles = {
    width: "112px",
    height: "42px",
    padding: "0px",
    minHeight: "42px",
    textTransform: "none",
    // color:"#2262ED !important",
  };
  const mobileTabStyles = {
    width: "50%",
    height: "42px",
    padding: "0px",
    minHeight: "42px",
    textTransform: "none",
    // color:"#2262ED !important"
  };
  const tabIconStyle = {
    path: {
      fill: "red",
    },
  };
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (accountInfo.length > 0) setSelectedPlatform(accountInfo[0].val.id);
  }, [accountInfo]);

  function checkIfCurrPlatformSupportsPublish() {
    let currPlatformName = accountInfo.filter(
      (acc) => acc.val.id == selectedPlatform
    );
    currPlatformName = currPlatformName[0].val.work_platform.name;
    return PUBLISH_PLATFORMS.includes(currPlatformName);
  }

  useEffect(() => {
    if (selectedPlatform) {
      setTabValue("Insights");
    }
  }, [selectedPlatform]);

  return (
    <>
      {accountInfo.length > 0 && selectedPlatform && (
        <div className="acc-nav-bar">
          <div className="acc-interaction-btns-container">
            <div className="acc-nav-workplatform-btns-container">
              {accountInfo.map((acc, index) => {
                // if (acc.val.status === PHYLLO_CONNECTED_KEY)
                return (
                  <ButtonWithImg
                    icon={acc.val.work_platform.logo_url}
                    text={acc.val.work_platform.name}
                    active={selectedPlatform === acc.val.id ? true : false}
                    key={acc.val.id}
                    click={() => setSelectedPlatform(acc.val.id)}
                  />
                );
              })}
            </div>
            <div className="add-account-btn-container">
              {!mobileBreakPoint && (
                <ButtonWithImg
                  // className="addAccountBtn"
                  fontWeight="500"
                  icon={add_account_btn}
                  text={"Add account"}
                  click={() => launchSDK(setLoader, history)}
                />
              )}
              {mobileBreakPoint && (
                <IconButton
                  aria-label="add-account-btn"
                  sx={{
                    width: "48px",
                    height: "48px",
                    border: "2px solid #EBEBEF",
                    backgroundColor: "#fffefe",
                  }}
                  onClick={() => launchSDK(setLoader, history)}
                >
                  <AddCircleIcon
                    sx={{ width: "36px", height: "36px", fill: "#D4D3D9" }}
                  />
                </IconButton>
              )}
            </div>
          </div>
          <Divider
            className="divider"
            variant={mobileBreakPoint ? "fullWidth" : "middle"}
            sx={
              mobileBreakPoint
                ? {
                    marginLeft: "-20px",
                    marginRight: "-20px",
                    borderWidth: "1px",
                  }
                : { borderWidth: "1px" }
            }
          />
          <Tabs
            className="tabsGroup"
            value={tabValue}
            onChange={(ev, value) => setTabValue(value)}
            aria-label="icon position tabs example"
            sx={mobileBreakPoint ? { width: "100%" } : { height: "42px" }}
          >
            <Tab
              icon={
                <InsightIcon
                  color={tabValue === "Insights" ? "#2262ED" : "#757480"}
                />
              }
              iconPosition="start"
              label="Insights"
              sx={mobileBreakPoint ? mobileTabStyles : tabStyles}
              value="Insights"
            />
            {checkIfCurrPlatformSupportsPublish() && (
              <Tab
                icon={
                  <PublishIcon
                    color={tabValue === "Publish" ? "#2262ED" : "#757480"}
                  />
                }
                sx={mobileBreakPoint ? mobileTabStyles : tabStyles}
                iconPosition="start"
                label="Publish"
                value="Publish"
              />
            )}
          </Tabs>
        </div>
      )}
    </>
  );
}

export default AccountNavBar;
